import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
 
import { configs } from '../../../constants/configs/configs';
import { useMultiHousehold } from '../../../hooks';
import {
    setActiveHouseholdId
} from '../../../actions/individualPortal/dashboard/dashboardActionCreators';

const ACTIVE_HOUSEHOLD_ID = 'activeHouseholdId';
 
const StyledHeader = styled.div`
    background: #f7f7f7;
    min-height: 20px;
    padding: 9px 15px;
    border-bottom: 1px solid #eee;
 
    .header {
        font-size: 2rem;
        font-weight: 500;
    }
 
    .second {
        font-size: 1.3rem;
    }
`;
 
const StyledContainer = styled.div`
    border: 1px solid #eee;
`;
 
const StyledLabel = styled.label`
    font-size: 1.3rem;
 
    input {
        margin-left: 1em;
        vertical-align: middle;
    }
`;
 
const StyledMembers = styled.span`
    padding-left: 2.7em;
    font-size: 1.3rem;
    margin: 0 0 0 2px;
`;
 
const StyledButtonPanel = styled.div`
    display: flex;
    justify-content: flex-end;
`;
 
function MultiHouseholdDetailsContainer(props) {
    const {
        environment: {
            devEnvironment,
            flags: {
                multiHouseholdEnabled
            }
        },
        setActiveHouseholdId
    } = props;

    const location = useLocation();
    const showOldModal = false;
    let myForm = null;
    const { multiHouseholdDetails, setActiveHousehold } = useMultiHousehold(multiHouseholdEnabled);
    const [ showMultiHouseholdDetails, setShowMultiHouseholdDetails ] = useState(false);
    const [ isShowRequiredOptions, setShowRequiredOptions ] = useState(false);
    const {
        routes
    } = configs;

    useEffect(() => {
        // console.error('In MultiHouseholdDetailsContainer: route has been changed = ', location);
        const acitveHouseholdIdFromStorage =  localStorage.getItem(ACTIVE_HOUSEHOLD_ID);
        const isInitialMP = location.pathname === routes.INDPORTAL && location.search === '' && (acitveHouseholdIdFromStorage === null || acitveHouseholdIdFromStorage === '');
        const isMultiHouseholdRoute = location.pathname === routes.INDPORTAL && location.search.includes('showMultiHH');
        if (multiHouseholdDetails.length > 0 && devEnvironment !== null && multiHouseholdEnabled && (isInitialMP || isMultiHouseholdRoute)) {
            setShowMultiHouseholdDetails(true);
        }
    }, [ multiHouseholdEnabled, location.pathname, multiHouseholdDetails]);

    const onSetActiveHousehold = (e) => {
        e.preventDefault();
        const { households } = myForm;
        if (households.value) {
            setActiveHousehold(households.value)
                .then(() => {
                    setShowMultiHouseholdDetails(false);
                    setActiveHouseholdId(households.value);
                    localStorage.setItem(ACTIVE_HOUSEHOLD_ID, households.value);
                    window.location.href=`${routes.INDPORTAL}?goDash=true`;
                })
                .catch(err => {
                    console.error('In MultiHouseholdDetailsContainer: onSetActiveHousehold(): error resp from API = ', err);
                    setShowMultiHouseholdDetails(false);
                });
        } else {
            setShowRequiredOptions(true);
        }
    };
 
    const renderMembers = members => {
        return (
            <div>
                {
                    members.map((member, idx) => (
                        <p key={`${member.firstName}_${idx}`}>
                            <StyledMembers>{ member.firstName } { member.middleName } { member.lastName } { member.suffix }</StyledMembers>
                        </p>
                    ))
                }
            </div>
        );
    };
 
    const renderHouseholds = () => {
        return multiHouseholdDetails.map(household => {
            return (
                <Fragment key={household.id}>
                    <StyledContainer>
                        <div>
                            <StyledLabel htmlFor={household.id} className="control-label">
                                <input
                                    id={household.id}
                                    type="radio"
                                    name="households"
                                    value={household.id}
                                    required
                                />
                                {' '}
                                {
                                    household.active &&
                                    <FormattedMessage id="multiHousehold.selectHousehold.active"/>
                                }
                                {
                                    !household.active &&
                                    <Fragment>
                                        <FormattedMessage id="multiHousehold.selectHousehold"/> <b><FormattedMessage id="multiHousehold.selectHousehold.notActive"/></b>
                                    </Fragment>
                                }
                            </StyledLabel>
                        </div>
                        { renderMembers(household.members) }
                    </StyledContainer>
                    <p />
                </Fragment>
            );
        });
    };
 
    const onHide = () => setShowMultiHouseholdDetails(false);
 
    const HouseholdModal = (props) => {
        return (
            <Modal
                show={ showMultiHouseholdDetails }
                onHide={props.onHide}
                size="md"
                shouldCloseOnEsc={false}
                shouldCloseOnOverlayClick={false}
                centered
            >
                <StyledHeader>
                    <div className="header"><FormattedMessage id="multiHousehold.headerSelect"/></div>
                    <p><div className="second"><FormattedMessage id="multiHousehold.headerParagraph"/></div></p>
                    <p><div className="second"><FormattedMessage id="multiHousehold.headerNote"/></div></p>
                </StyledHeader>
                <Modal.Body>
                    {
                        isShowRequiredOptions &&
                        <div className="error--msg second shown margin-t-0 margin-b-10">
                            <em>
                                <FontAwesomeIcon icon="exclamation"/>
                            </em>
                            <FormattedMessage id="multiHousehold.select.options.required" />
                        </div>
                    }
                    <form ref={form => myForm = form}>
                        { renderHouseholds() }
                        <StyledButtonPanel>
                            <button
                                type="submit"
                                className='usa-button gi-button gi-button__primary'
                                onClick={ props.onSetActiveHousehold }
                            >
                                <FormattedMessage id="continue_btn" />
                            </button>
                        </StyledButtonPanel>
                    </form>
                </Modal.Body>
            </Modal>
        );
    };

    const renderOldModal = () => {
        window.location.href = '/hix/indportal#/multiHousehold';
    };
 
    return (
        <Fragment>
            {
                showMultiHouseholdDetails && !showOldModal &&
                <HouseholdModal {...{ multiHouseholdDetails, onSetActiveHousehold, onHide }} />
            }
            {
                showMultiHouseholdDetails && showOldModal &&
                renderOldModal()
            }
        </Fragment>
    );
}
 
const mapStateToProps = state => ({
    environment: state.common.environment
});
 
export default connect(mapStateToProps, { setActiveHouseholdId })(MultiHouseholdDetailsContainer);